import { useEffect, useState } from "react";
import {
  InputCoDobNow,
  OutputCoDobNow,
} from "../../../Services/Serverless/Lookup/Co/Co.interface";
import { QueueMethods } from "../../../Services/Serverless/Queue/Queue.interface";
import Loading from "../../Infrastructure/Loading";
import pollingQueue from "../../../Services/Serverless/pollingQueue";
import moment from "moment-timezone";

export default function CosDobNow({
  bin,
  streetName,
  houseNo,
  boro,
}: {
  bin: string;
  streetName: string;
  houseNo: string;
  boro: string;
}) {
  const [cos, setCos] = useState<OutputCoDobNow | undefined>(undefined);
  useEffect(() => {
    const method = QueueMethods.COS_DOBNOW;
    const inputData = {
      houseNo,
      streetName,
      boro,
      bin,
    };
    const intervalHandle = pollingQueue<InputCoDobNow, OutputCoDobNow>({
      method,
      input: inputData,
      setData: setCos,
      maxPoll: 40,
    });
    return () => {
      if (intervalHandle) clearInterval(intervalHandle);
    };
  }, []);
  return (
    <div className="cos">
      <h3>DoB NOW (March of 2021 and later)</h3>
      {cos === undefined ? (
        <Loading />
      ) : (
        <>
          {cos.pdfLinks.length === 0 ? (
            <div>No certificate of occupancy found</div>
          ) : (
            <>
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Link</th>
                    <th>Job No.</th>
                  </tr>
                </thead>
                <tbody>
                  {cos.pdfLinks.map((pdfLink, i) => (
                    <tr key={pdfLink.url + i}>
                      <td>
                        {pdfLink.certInfo?.CreatedOn &&
                          moment(
                            pdfLink.certInfo?.CreatedOn,
                            "MM/DD/YYYY",
                          ).format("YYYY-MM-DD")}
                      </td>
                      <td>{pdfLink.certInfo?.COTypeRequested}</td>
                      <td>
                        <a href={pdfLink.url} target="_blank" rel="noreferrer">
                          {pdfLink.filename}.PDF
                        </a>
                      </td>
                      <td>{pdfLink.certInfo?.AssociatedJobNumber}</td>
                      {/**
                      <td>
                        {pdfLink.certInfo && (
                          <pre>{JSON.stringify(pdfLink.certInfo, null, 2)}</pre>
                        )}
                      </td>
                      */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </>
      )}
    </div>
  );
}
